@let isLoggedIn = isLoggedIn$ | async;
@if (isLoggedIn) {
  @if (banner) {
    <app-cta-banner
      [banner]="banner"
      (closeBanner)="closeBanner()"
    ></app-cta-banner>
  }

  <app-top-bar></app-top-bar>

  @let ob = omnisearchData$ | async;
  @if (ob) {
    <div [style.display]="ob.omnisearchFocused ? 'none' : 'block'">
      <router-outlet></router-outlet>
    </div>

    @if (ob.omnisearchFocused) {
      <app-omnisearch-results-container
        [showClose]="showClose"
        [results]="ob.omnisearchResults"
        [searchType]="ob.queryType"
        [viewedOpportunityName]="ob.omnisearchProjectName"
      >
      </app-omnisearch-results-container>
    }
  }
} @else {
  <app-loader></app-loader>
}
